module.exports = __webpack_public_path__ + "static/media/kitchen-1336160_1920.33aa8849.jpg";